<template>
    <div>
        <estimates-old-specs-item-sidepage-header
            :form="form"
            :quantity="item.group_use_custom_quantities ? itemSpec.quantity : undefined"
            :read-only="estimate.cannot_be_edited_by_authed_user"
            @update:quantity="updateQuantity"
            class="rounded-t-lg -mb-px"
            @updated="submitForm"
            @duplicate-and-replace="$store.duplicateAndReplaceSpecFromItem(item, itemSpec, spec)"
            @detach="$store.detachSpecFromItem(item, itemSpec, spec)"
            @copy-to-global-spec="$store.copyToGlobalSpec(spec)"
        ></estimates-old-specs-item-sidepage-header>
        <global-specs-form-table
            compact-mode
            :form="form"
            :estimate="estimate"
            :read-only="estimate.cannot_be_edited_by_authed_user"
            :quantity="item.group_use_custom_quantities ? itemSpec.quantity : undefined"
            @updated="submitForm"
        ></global-specs-form-table>
    </div>
</template>

<script>
import { estimateStore } from '@stores'
import { debounce } from 'lodash'

export default {
    props: {
        item: Object,
        itemSpec: Object,
    },
    data () {
        const spec = estimateStore.findLocalSpec(this.itemSpec.spec_id)

        return {
            spec: spec,
            form: new Form(spec.getFormAttributes(), async (form) => {
                await this.spec.update(form.export())
                form.materials_cost_per_uom = this.spec.materials_cost_per_uom
                form.labour_cost_per_uom = this.spec.labour_cost_per_uom
                form.cost_per_uom = this.spec.cost_per_uom
            }),
        }
    },
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return this.$store.state.estimate
        },
    },
    methods: {
        updateQuantity (quantity) {
            this.itemSpec.quantity = quantity
            this.$store.recalculateItem(this.item, true)
            this.$store.save()
        },
        submitForm: debounce(async function (payload = {}) {
            await this.form.submit()
            if (payload?.is_material_change) {
                this.$store.refreshAndRecalculateLocalSpecs()
            } else {
                this.$store.recalculateTotals()
            }
            this.$store.save()
        }, 300),
    },
    watch: {
        ['spec.materials']: {
            deep: true,
            handler (updatedMaterials) {
                this.form.setData({ materials: updatedMaterials })
            },
        }
    },
}
</script>
